import { getNotificationTemplatesFromDsl } from './getNotificationTemplatesFromDsl';
import type { DerivedNotificationRow } from './types';

export type DeriveResult =
  | { kind: 'ok'; rows: DerivedNotificationRow[] }
  | { kind: 'error'; error: string };

export async function deriveNotificationRows(
  dslSource: string
): Promise<DeriveResult> {
  if (dslSource.trim() === '') {
    return { kind: 'ok', rows: [] };
  }
  try {
    const templates = await getNotificationTemplatesFromDsl(dslSource);
    return {
      kind: 'ok',
      rows: templates.flatMap(({ name, channels }) =>
        channels.map(channel => ({ notificationTemplateId: name, channel }))
      ),
    };
  } catch (e) {
    return {
      kind: 'error',
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
